import { HDate } from "@shared/src/datatypes/HDate";
import { AddressDaySettingPlanningDockDto } from "./AddressDaySettingPlanningDockDto";
import { AddressTimetableIntervalDockDto } from "./AddressTimetableIntervalDockDto";
import { DockDto } from "./DockDto";
import { DockSlotsDto } from "./DockSlotsDto";
import { HHourInterval } from "@shared/src/datatypes/HHourInterval";
import { DockSlotPhaseDto } from "./DockSlotPhaseDto";
import { PhaseSlotDto } from "../../phase/slot/PhaseSlotDto";
import { HColor } from "@shared/src/datatypes/HColor";
import { HHour, HTime } from "@shared/src/public-api";
import { AddressDockIntervalBaseDto } from "./AddressDockIntervalBaseDto";


export class AddressDockAbsoluteDto {

    public static ALTURAMINIMA: number = 200;
    public static DESPLAÇAMENT: number = 20;
    public static MARGE: number = 2;
    public docks: Array<AddressDockAbsoluteDockDto>;
    public lines: Array<AddressDockAbsoluteLineDto>;
    public minHeight: number = 0;
    public static buildNull(): AddressDockAbsoluteDto {
        let result = new AddressDockAbsoluteDto();
        result.docks = [];
        result.lines = [];
        return result;
    }
    //NORMAL, DOCK, FORKLIFT
    public static build(p: AddressDaySettingPlanningDockDto, slotsMode: String): AddressDockAbsoluteDto {
        let result = new AddressDockAbsoluteDto();

        result.docks = new Array();
        if (p.docksDefinedAndNotDefined != null)
            p.docksDefinedAndNotDefined.forEach(x => {
                let dock = AddressDockAbsoluteDockDto.build(x);
                result.docks.push(dock);
                result.getLoads(p.intervals, dock).forEach(y => {
                    dock.phases.push(y);
                });
            });

        this.formatejar(result, slotsMode);
        return result;
    }


    static formatejar(result: AddressDockAbsoluteDto, slotsMode: String) {
        let horaMinima = HHour.HOUR_48;
        let duradaMinima = HTime.build(24 * 60);
        result.docks.forEach(x => {
            x.phases.forEach(y => {
                let interval = AddressDockAbsoluteDto.getInterval(y, "DOCK");
                //horaMinima = HHour.min(horaMinima, HHourInterval.getStarts(interval));
                duradaMinima = HTime.min(duradaMinima, HHourInterval.totalOf(interval));
                let intervalPerInici = AddressDockAbsoluteDto.getInterval(y, slotsMode);
                horaMinima = HHour.min(horaMinima, HHourInterval.getStarts(intervalPerInici));
            });
        });

        let thoraMinima = HTime.fromHHour(horaMinima);
        let alturaMinima = AddressDockAbsoluteDto.ALTURAMINIMA;
        let nduradaMinima = HTime.toMinutes(duradaMinima);
        let alturaMinut = Math.ceil(alturaMinima / nduradaMinima);
        result.lines = new Array();
        result.docks.forEach(x => {
            x.phases.forEach(y => {
                let interval = AddressDockAbsoluteDto.getInterval(y, slotsMode);

                let respecteInici = HTime.operatorMinus(HTime.fromHHour(HHourInterval.getStarts(interval)), thoraMinima)
                y.top = (HTime.toMinutes(respecteInici) * alturaMinut) + AddressDockAbsoluteDto.DESPLAÇAMENT;
                let durada = HHourInterval.totalMinutes(interval);
                y.height = (durada * alturaMinut) - AddressDockAbsoluteDto.MARGE;

                if (!existeixLinia(result.lines, y.top)) {
                    result.lines.push(AddressDockAbsoluteLineDto.build(y.top, HHourInterval.getStarts(interval)));
                }
                result.minHeight = Math.max(result.minHeight, y.top + y.height + AddressDockAbsoluteDto.ALTURAMINIMA);
            });
        });
    }
    static getInterval(y: AddressDockIntervalBaseDto, slotsMode: String): HHourInterval {
        if ("FORKLIFT" == slotsMode)
            return y.intervalWheelbarrowDriver;
        else if ("DOCK" === slotsMode)
            return y.intervalDock;

        return y.interval;
    }

    public getLoads(intervals: Array<AddressTimetableIntervalDockDto>, dock: AddressDockAbsoluteDockDto): Array<AddressDockAbsolutePhaseDto> {

        let result = new Array<AddressDockAbsolutePhaseDto>();
        intervals.forEach(d => {
            d.dockSlotsColumn.forEach(y => {
                if (y.dock.dockId == dock.dockId)
                    y.dockSlots.forEach(z => {
                        if (z.phaseId != null && z.phaseId != 0)
                            result.push(AddressDockAbsolutePhaseDto.build(d, y, z));
                    });
            });
        });
        return result;
    }
}

export class AddressDockAbsoluteDockDto {
    public dockId: number;
    public backgroundColor: string;
    public phases: Array<AddressDockAbsolutePhaseDto>;
    public skin: string;

    static build(x: DockDto): AddressDockAbsoluteDockDto {
        let result = new AddressDockAbsoluteDockDto();
        result.dockId = x.dockId;
        result.backgroundColor = HColor.getColorOpacity(x.backgroundColor, "", .2);
        result.phases = new Array();
        result.skin = x.skin;
        return result;
    }
}
export class AddressDockAbsoluteLineDto {
    public top: number;
    public hour: HHour;

    public static build(top: number, hour: HHour): AddressDockAbsoluteLineDto {
        let result = new AddressDockAbsoluteLineDto();
        result.top = top;
        result.hour = hour;
        return result;
    }
}

export class AddressDockAbsolutePhaseDto extends AddressDockIntervalBaseDto {
    public style: string;

    public phaseId: number;
    public slotPlanning: PhaseSlotDto;
    public isAvailable: boolean;
    public isEmptyDock: boolean;

    public dockId: number;
    public dockSkin: string;
    public dockBackgroundColor: HColor;

    public top: number;
    public height: number;
    public left: number;
    public width: number;

    static build(d: AddressTimetableIntervalDockDto, y: DockSlotsDto, z: DockSlotPhaseDto): AddressDockAbsolutePhaseDto {
        let result = new AddressDockAbsolutePhaseDto();
        result.addressTimetableIntervalId = d.addressTimetableIntervalId;
        result.addressDaySettingId = d.addressDaySettingId;
        result.onDate = d.onDate;
        result.interval = d.interval;
        result.intervalDock = d.intervalDock;
        result.intervalWheelbarrowDriver = d.intervalWheelbarrowDriver;
        result.dockSlotCount = d.dockSlotCount;
        result.dockSlotOccupied = d.dockSlotOccupied;
        result.dockSlotAvailable = d.dockSlotAvailable;
        result.dockSlots = d.dockSlots;
        result.dockSlotsColumn = d.dockSlotsColumn;
        result.dockSlotsPending = d.dockSlotsPending;
        result.userTags = d.userTags;
        result.backColor = d.backColor;
        result.canalterelement = d.canalterelement;

        result.phaseId = z.phaseId;
        result.slotPlanning = z.slotPlanning;
        result.isAvailable = z.isAvailable;
        result.isEmptyDock = z.isEmptyDock;
        result.dockId = z.dockId;
        result.dockSkin = z.dockSkin;
        result.dockBackgroundColor = z.dockBackgroundColor;

        return result;
    }

}

function existeixLinia(lines: AddressDockAbsoluteLineDto[], top: number): boolean {
    return lines.some(l => l.top === top);
}
